module.exports = __webpack_public_path__ + "img/Componente 37 – 1.a6774a52.svg";